import React, { useState } from "react";
import styles from "./patientProfile.module.scss";
import { Dropdown, Input, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { Spinner } from "react-bootstrap";
import { RpmProfileReportsRowLayout } from "../../../RpmModule/Components/PatientDetails/Components/RpmProfileold/RpmProfileReportsRowLayout";
import { RpmOtherDetailsGridLayout } from "../../../RpmModule/Components/PatientDetails/Components/RpmProfileold/RpmOtherDetailsGridLayout";
import CustomPhoneInputV2 from "../../../CustomPhoneInputV2/CustomPhoneInputV2";
import { RpmStatusTriangle } from "../../../../assets/Logos/Icons";
import { Assets } from "../../../../assets/Assets";

const Profile = () => {
  const _dummyVitalsData = {
    overallstatus: "Normal",
    weightValue: 70, // Change to the desired weight value
    heightValue: 175, // Change to the desired height value
    pulserate: 72, // Change to the desired pulse rate
    puldate: "2023-08-23", // Change to the desired date format
    pulseratetatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    body_temp: 98.6, // Change to the desired body temperature
    body_tempdate: "2023-08-23", // Change to the desired date format
    body_tempstatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    glucose: 120, // Change to the desired glucose level
    blood_sugardate: "2023-08-23", // Change to the desired date format
    blood_sugerstatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    blood_oxygen: 98, // Change to the desired blood oxygen level
    blood_oxygendate: "2023-08-23", // Change to the desired date format
    blood_oxygenstatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    systolic: 120, // Change to the desired systolic pressure
    diastolic: 80, // Change to the desired diastolic pressure
    systolicstatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    diastolicstatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
    date: "2023-08-23", // Change to the desired date format
    ecgheart_rate: 80, // Change to the desired ECG heart rate
    ecgdate: "2023-08-23", // Change to the desired date format
    ecgheartratestatus: "normal", // Change to the desired status ("normal", "critical", "up", "down")
  };

  // Now you can use this dummyVitalsData object in your code.

  let [isEditOpen, setEditOpen] = useState(false);
  let [editItem, setEditItem] = useState(null);
  let [updatedData, setUpdatedData] = useState();
  const [vitalsData, setVitalsData] = useState(_dummyVitalsData);
  let [packageDetails, setPackageDetails] = useState([]);

  let [formData, setFormData] = useState({
    EmergencyContactaddress1: "",
    EmergencyContactaddress2: "",
    EmergencyContactalternativephoneNumber: "",
    EmergencyContactcity: "",

    EmergencyContactcountry: "",

    EmergencyContactlandmark: "",

    EmergencyContactname: "",
    EmergencyContactphoneNumber: "",
    EmergencyContactPIN: "",

    EmergencyContactrelationship: "",
    EmergencyContactstate: "",
    InsuranceExpiryDate: "",
    InsuranceCompany: "",
    InsuranceMemberNumber: "",
    RegularDoctorphoneNumber: "",
    RegularDoctorname: "",
    RegularDoctorpracticeName: "",

    Informationaddress1: "",
    Informationaddress2: "",
    Informationage: "",
    Informationbloodgroup: "",
    Informationcity: "",
    Informationcountry: "",
    Informationdob: "",
    Informationemailid: "",
    Informationfullname: "",
    Informationgender: "",
    Informationheight: "",
    InformationheightValue: "",
    Informationlandmark: "",

    Informationmaritalstatus: "",
    InformationnationalId: "",
    Informationnationality: "",
    Informationoccupation: "",
    Informationmobilenumber: "",
    InformationPIN: "",
    InformationprofileImage: "",
    Informationsincefrom: "",
    Informationstate: "",
    Informationweight: "",
    InformationweightValue: "",
    packagerejectreason: "",
  });

  let editOptions = [
    "Personal Info",
    "Regular Doctor",
    "Emergency Contact",
    "Insurance",
    "profile",
  ];

  const patientDetails = {
    Information: {
      profileImage: "",
      fullname: "John Doe",
      age: 30,
      gender: "Male",
      sincefrom: "Jan 1, 2020",
      bloodgroup: "A+",
      maritalstatus: "Married",
      heightValue: "5'10\"",
      weightValue: "160 lbs",
      occupation: "Engineer",
      emailid: "john@example.com",
      mobilenumber: "123-456-7890",
      nationality: "US",
      nationalId: "123456789",
      address1: "123 Main St",
      address2: "Apt 4B",
      city: "New York",
      landmark: "Near Central Park",
      PIN: "10001",
      state: "NY",
      country: "USA",
    },
    RegularDoctor: {
      name: "Dr. Smith",
      practiceName: "Smith Clinic",
      phoneNumber: "987-654-3210",
    },
    EmergencyContact: {
      name: "Jane Doe",
      relationship: "Spouse",
      phoneNumber: "555-555-5555",
      alternativephoneNumber: "555-123-4567",
      address1: "456 Elm St",
      address2: "Suite 2C",
      city: "New York",
      landmark: "Near Library",
      PIN: "10002",
      state: "NY",
      country: "USA",
    },
    Insurance: {
      Company: "Health Insurance Inc.",
      MemberNumber: "H1234567",
      ExpiryDate: "Dec 31, 2024",
    },
    repots: [], // Assuming there are no reports initially
  };
  let messagenodata = "NA";

  let repots = [];

  let handleEditOk = () => {
    console.log(
      "Only changed Items will store in state and log here ==> ",
      updatedData
    );

    setEditOpen(false);
  };

  let handleEditClose = () => {
    setEditOpen(false);
  };

  let handleEditSelectChange = (value, e) => {
    setUpdatedData({
      ...updatedData,
      [e]: value,
    });
  };

  let handleEditInputChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.id]: e.target.value,
    });
  };

  let handleEditInputNumberChange = ({ key, value }) => {
    setUpdatedData({
      ...updatedData,
      [key]: `+${value}`,
    });
  };

  let classNames = {
    Normal: { tile: "normaltile" },
    Abnormal: { tile: "abnormaltile" },
    Critical: { tile: "criticaltile" },
  };
  let getDataFromVitals = (itemName, extension, ifEmpty) => {
    if (vitalsData && vitalsData[itemName]) {
      if (extension) {
        return vitalsData[itemName] + extension;
      } else {
        return vitalsData[itemName];
      }
    } else if (ifEmpty) {
      return "NA";
    } else {
      return "";
    }
  };

  const getBmi = () => {
    return (
      ((patientDetails?.Information.weightValue != undefined &&
        patientDetails?.Information.weightValue.split(" ")[0]) /
        (patientDetails?.Information.heightValue != undefined
          ? patientDetails?.Information.heightValue.split(" ")[0] *
            patientDetails?.Information.heightValue.split(" ")[0]
          : "")) *
      10000
    );
  };

  const getAddress = () => {
    let address = patientDetails?.Information?.address1
      ? patientDetails?.Information?.address1
      : "";
    address +=
      patientDetails?.Information?.address2 != ""
        ? ", " + patientDetails?.Information?.address2
        : "";
    address +=
      patientDetails?.Information?.city != undefined
        ? ", " + patientDetails?.Information?.city
        : "";
    address +=
      patientDetails?.Information?.landmark != ""
        ? ", " + patientDetails?.Information?.landmark
        : "";
    address +=
      patientDetails?.Information?.state != undefined
        ? ", " + patientDetails?.Information?.state
        : "";
    address +=
      patientDetails?.Information?.country != undefined
        ? ", " + patientDetails?.Information?.country
        : "";
    address +=
      patientDetails?.Information?.PIN != undefined
        ? ", " + patientDetails?.Information?.PIN
        : "";

    return address;
  };

  const getEmail = () => {};

  return (
    <div className={styles.patientProfileContainer}>
      {patientDetails === undefined ? (
        <div className={styles.loader}>
          {/* ****IMPORTANT Loader is not working */}
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <div className={styles.patientProfileContainer_row}>
            <div className={styles.profileMain}>
              <div className={`${styles.userDetails} ${styles.itemContainer}`}>
                <img
                  src={
                    patientDetails?.Information?.profileImage
                      ? patientDetails?.Information?.profileImage
                      : "https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg"
                  }
                  alt="user"
                />

                <span className={styles.age}>
                  <b>Age : &nbsp;</b>{" "}
                  {formData.Informationage
                    ? formData.Informationage + " years"
                    : messagenodata}
                </span>
                <span className={styles.age}>
                  <b>Gender : &nbsp;</b>{" "}
                  {patientDetails?.Information?.gender
                    ? patientDetails?.Information?.gender
                    : messagenodata}
                </span>
                <span className={styles.duration}>
                  <b>Member since &nbsp;</b>
                </span>
                <span className={styles.duration}>
                  {" "}
                  {patientDetails.Information.sincefrom}
                </span>
              </div>

              <RpmProfileReportsRowLayout>
                <div
                  className="rpm-profile-grid-item"
                  style={{ background: "#fff" }}
                >
                  <div
                    className={`white-container  ${
                      classNames[
                        vitalsData?.overallstatus !== undefined
                          ? vitalsData.overallstatus
                          : "Normal"
                      ]?.tile
                    }`}
                    style={{ padding: "0", margin: "0" }}
                  >
                    <div
                      className={styles.patientDashboardTile_body_consultation}
                      style={{ padding: "0px 10px", lineHeight: "1.9" }}
                    >
                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          Weight:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("weightValue", "", "NA")}{" "}
                        </span>
                      </div>
                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          Height:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("heightValue", "", "NA")}{" "}
                        </span>
                      </div>
                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          BMI:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getBmi()?.toFixed(2) || "NA"}
                        </span>
                      </div>

                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          Pulse:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("pulserate", " bpm", "-")}
                          {/* {vitalsData?.pulserate
                                    ? vitalsData.pulserate + " bpm"
                                    : "-"}{" "} */}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {getDataFromVitals("puldate", "", "") &&
                            `(${getDataFromVitals("puldate", "", "")})`}
                          {/* 
                                    {vitalsData?.puldate
                                    ? " (" + vitalsData.puldate + ") "
                                    : ""} */}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.pulserate ? (
                            <RpmStatusTriangle
                              variant={
                                getDataFromVitals("pulseratetatus", "", "")
                                  ? vitalsData.pulseratetatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.pulseratetatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          Temperature:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("body_temp", " °C", "-")}
                          {/* {vitalsData?.body_temp ? vitalsData.body_temp + " C" : "-"}{" "} */}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {getDataFromVitals("body_tempdate", "", "") &&
                            `(${getDataFromVitals("body_tempdate", "", "")})`}
                          {/* {vitalsData?.body_tempdate
                                    ? " (" + vitalsData.body_tempdate + ") "
                                    : ""} */}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.body_tempstatus ? (
                            <RpmStatusTriangle
                              variant={
                                getDataFromVitals("body_tempstatus", "", "")
                                  ? vitalsData.body_tempstatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.body_tempstatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>

                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          Glucose:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("glucose", " mmol/L", "-")}
                          {/* 
                                    {vitalsData?.glucose
                                    ? vitalsData.glucose + " mmol/L"
                                    : "-"}{" "} */}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {getDataFromVitals("blood_sugardate", "", "") &&
                            `(${getDataFromVitals("blood_sugardate", "", "")})`}
                          {/* {vitalsData?.blood_sugardate
                                    ? " (" + vitalsData.blood_sugardate + ") "
                                    : ""} */}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.blood_sugerstatus ? (
                            <RpmStatusTriangle
                              variant={
                                getDataFromVitals("blood_sugerstatus", "", "")
                                  ? vitalsData.blood_sugerstatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.blood_sugerstatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>

                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          SpO2:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {getDataFromVitals("blood_oxygen", " %", "-")}
                          {/* {vitalsData?.blood_oxygen
                                    ? vitalsData.blood_oxygen + " %"
                                    : "-"}{" "} */}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {getDataFromVitals("blood_oxygendate", "", "") &&
                            `(${getDataFromVitals(
                              "blood_oxygendate",
                              "",
                              ""
                            )})`}
                          {/* {vitalsData?.blood_oxygendate
                                    ? " (" + vitalsData.blood_oxygendate + ") "
                                    : ""} */}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.blood_oxygenstatus ? (
                            <RpmStatusTriangle
                              variant={
                                getDataFromVitals("blood_oxygenstatus", "", "")
                                  ? vitalsData.blood_oxygenstatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.blood_oxygenstatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>

                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          BP:
                        </span>

                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.systolicstatus ? (
                            <RpmStatusTriangle
                              variant={
                                vitalsData?.systolicstatus != ""
                                  ? vitalsData.systolicstatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.systolicstatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                          {/* {vitalsData?.systolicstatus ? (
                                    <RpmStatusTriangle
                                        variant={
                                        vitalsData.systolicstatus != ""
                                            ? vitalsData.systolicstatus
                                            : "normal"
                                        }
                                        size="13"
                                        direction="up"
                                    />
                                    ) : (
                                    ""
                                    )} */}
                        </span>

                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {vitalsData?.systolic ? vitalsData?.systolic : ""}
                          {vitalsData?.diastolic
                            ? "/" + vitalsData?.diastolic
                            : ""}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.diastolicstatus ? (
                            <RpmStatusTriangle
                              variant={
                                vitalsData?.diastolicstatus != ""
                                  ? vitalsData?.diastolicstatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.diastolicstatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>

                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {vitalsData?.systolic && vitalsData?.diastolic
                            ? " mmHg"
                            : "NA"}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {vitalsData?.date
                            ? " (" + vitalsData.date + ") "
                            : ""}
                        </span>
                      </div>

                      <div className={styles.patientDashboardTile_body_item}>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_question
                          }
                        >
                          ECG:
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_answer
                          }
                        >
                          {vitalsData?.ecgheart_rate
                            ? vitalsData.ecgheart_rate + " bpm"
                            : "NA"}
                        </span>
                        <span
                          className={styles.patientDashboardTile_body_item_time}
                        >
                          {vitalsData?.ecgdate
                            ? " (" + vitalsData.ecgdate + ") "
                            : ""}
                        </span>
                        <span
                          className={
                            styles.patientDashboardTile_body_item_status
                          }
                        >
                          {vitalsData?.ecgheartratestatus ? (
                            <RpmStatusTriangle
                              variant={
                                vitalsData.ecgheartratestatus != ""
                                  ? vitalsData.ecgheartratestatus
                                  : "normal"
                              }
                              size="13"
                              direction={
                                vitalsData.ecgheartratestatus === "critical"
                                  ? "up"
                                  : "down"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rpm-profile-grid-item">
                  <div className={styles.itemHeader}>
                    <div className={styles.icon}>
                      <img src={Assets.profile} alt="rpm files" />
                      <b>Package Info</b>
                    </div>

                    <p className="packagestatus">
                      {packageDetails?.status === "Requested"
                        ? packageDetails?.status
                        : packageDetails?.status?.includes("Accepted")
                        ? "Payment Pending"
                        : packageDetails?.status}{" "}
                    </p>
                  </div>
                  <div
                    className="report-details"
                    style={{ textAlign: "center" }}
                  >
                    <table className={styles.itemTable}>
                      <tr>
                        <td>Package Name</td>
                        <td>:</td>
                        {/* ****IMPORTANT Check the blood group from the API */}
                        <td style={{ paddingLeft: "10px" }}>
                          {packageDetails?.packageName
                            ? packageDetails.packageName
                            : messagenodata}
                        </td>
                        <td style={{ paddingLeft: "10px" }}></td>
                      </tr>
                      <tr>
                        <td>Package Details</td>
                        <td>:</td>
                        {/* ****IMPORTANT Check the blood group from the API */}
                        <td style={{ paddingLeft: "10px", width: "50%" }}>
                          {packageDetails?.packageshortdescription
                            ? packageDetails.packageshortdescription
                            : messagenodata}
                        </td>
                        <td style={{ paddingLeft: "10px" }}></td>
                      </tr>
                      <tr>
                        <td>Package Amount</td>
                        <td>:</td>
                        {/* ****IMPORTANT Check the blood group from the API */}
                        <td style={{ paddingLeft: "10px" }}>
                          {packageDetails?.fees
                            ? packageDetails.fees
                            : messagenodata}
                        </td>
                        <td style={{ paddingLeft: "10px" }}></td>
                      </tr>
                      <tr></tr>
                    </table>
                  </div>
                </div>
              </RpmProfileReportsRowLayout>
            </div>
          </div>

          <div className="rpm-profile-container_row profile-other-infos">
            <RpmOtherDetailsGridLayout>
              <div className={`rpm-profile-grid-item ${styles.item}`}>
                <div className={styles.itemHeader}>
                  <div className={styles.icon}>
                    <img src={Assets.profile} alt="rpm files" />
                    <b>Personal Info</b>
                  </div>
                </div>

                <table className={styles.itemTable}>
                  <tr>
                    <td>Blood Group</td>
                    <td>:</td>
                    {/* ****IMPORTANT Check the blood group from the API */}
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.bloodgroup
                        ? patientDetails?.Information?.bloodgroup
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Marital Status</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.maritalstatus
                        ? patientDetails?.Information?.maritalstatus
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                  <tr>
                    <td>Height</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.heightValue
                        ? patientDetails?.Information?.heightValue
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                  <tr>
                    <td>Weight</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.weightValue
                        ? patientDetails?.Information?.weightValue
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>BMI</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {getBmi()?.toFixed(2) || messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                  <tr>
                    <td>Occupation</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.occupation
                        ? patientDetails?.Information?.occupation
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Email id</td>
                    <td>:</td>
                    {/* ****IMPORTANT display the data from patientdetails */}
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.emailid
                        ? patientDetails?.Information?.emailid
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Mobile Number</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.mobilenumber.length > 6
                        ? patientDetails?.Information?.mobilenumber.includes(
                            "+"
                          )
                          ? patientDetails?.Information?.mobilenumber
                          : "+" + patientDetails?.Information?.mobilenumber
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Nationality</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.nationality
                        ? patientDetails?.Information?.nationality
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                  <tr>
                    <td>National ID</td>
                    <td>:</td>
                    <td style={{ paddingLeft: "10px" }}>
                      {patientDetails?.Information?.nationalId
                        ? patientDetails?.Information?.nationalId
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Address</td>
                    <td>:</td>
                    <td
                      style={{
                        paddingLeft: "10px",
                        textTransform: "capitalize",
                      }}
                    >
                      {patientDetails?.Information?.address1
                        ? getAddress()
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>
              <div className={`rpm-profile-grid-item ${styles.item}`}>
                <div className={styles.itemHeader}>
                  <div className={styles.icon}>
                    <img
                      className="doctor-image"
                      src={Assets.doctor}
                      alt="rpm files"
                    />
                    <b>Treating Doctor</b>
                  </div>
                </div>

                <table className={styles.itemTable}>
                  <tr>
                    <td>Treating Doctor/Physician</td>
                    <td>:</td>
                    <td>
                      {patientDetails.RegularDoctor.name
                        ? patientDetails.RegularDoctor.name
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Hospital Name</td>
                    <td>:</td>
                    <td>
                      {patientDetails.RegularDoctor.practiceName
                        ? patientDetails.RegularDoctor.practiceName
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Contact Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.RegularDoctor?.phoneNumber &&
                      patientDetails.RegularDoctor.phoneNumber.length > 6
                        ? patientDetails.RegularDoctor.phoneNumber.includes("+")
                          ? patientDetails.RegularDoctor.phoneNumber
                          : "+" +
                            patientDetails.RegularDoctor.phoneNumber.trim()
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>
              <div className={`rpm-profile-grid-item ${styles.item}`}>
                <div className={styles.itemHeader}>
                  <div className={styles.icon}>
                    <img src={Assets.friends} alt="rpm files" />
                    <b>Emergency Contact</b>
                  </div>
                </div>

                <table className={styles.itemTable}>
                  <tr>
                    <td>Name</td>
                    <td>:</td>
                    <td>
                      {patientDetails.EmergencyContact.name
                        ? patientDetails.EmergencyContact.name
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Relationship</td>
                    <td>:</td>
                    <td>
                      {patientDetails.EmergencyContact.relationship
                        ? patientDetails.EmergencyContact.relationship
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Mobile Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails.EmergencyContact.phoneNumber
                        ? patientDetails.EmergencyContact.phoneNumber.includes(
                            "+"
                          )
                          ? patientDetails.EmergencyContact.phoneNumber
                          : "+" + patientDetails.EmergencyContact.phoneNumber
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Alternate Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.EmergencyContact
                        ?.alternativephoneNumber &&
                      patientDetails.EmergencyContact.alternativephoneNumber
                        .length > 6
                        ? patientDetails.EmergencyContact.alternativephoneNumber.includes(
                            "+"
                          )
                          ? patientDetails.EmergencyContact
                              .alternativephoneNumber
                          : "+" +
                            patientDetails.EmergencyContact
                              .alternativephoneNumber
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Address</td>
                    <td>:</td>
                    <td style={{ textTransform: "capitalize" }}>
                      {patientDetails.EmergencyContact?.address1
                        ? getEmail()
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>
              <div className={`rpm-profile-grid-item ${styles.item}`}>
                <div className={styles.itemHeader}>
                  <div className={styles.icon}>
                    <img src={Assets.insurance} alt="rpm files" />
                    <b>Insurance</b>
                  </div>
                </div>

                <table className={styles.itemTable}>
                  <tr>
                    <td>Provider Name</td>
                    <td>:</td>
                    <td>
                      {patientDetails.Insurance.Company
                        ? patientDetails.Insurance.Company
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Member Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails.Insurance.MemberNumber
                        ? patientDetails.Insurance.MemberNumber
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Expiry Date</td>
                    <td>:</td>
                    <td>
                      {patientDetails.Insurance.ExpiryDate
                        ? patientDetails.Insurance.ExpiryDate
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>
            </RpmOtherDetailsGridLayout>
          </div>
        </>
      )}
    </div>
  );
};

export default Profile;
